import React, { useEffect, useRef, useState, useCallback, memo } from "react";

const SessionTimer = memo(({ onTimeout, initialTime = 45 * 60 }) => {
  const [displayTime, setDisplayTime] = useState(initialTime);
  const timeLeftRef = useRef(initialTime);

  const resetTimer = useCallback(() => {
    timeLeftRef.current = initialTime;
    setDisplayTime(initialTime);
  }, [initialTime]);

  useEffect(() => {
    const handleActivity = () => resetTimer();
    window.addEventListener("click", handleActivity);
    window.addEventListener("keydown", handleActivity);
    return () => {
      window.removeEventListener("click", handleActivity);
      window.removeEventListener("keydown", handleActivity);
    };
  }, [resetTimer]);

  useEffect(() => {
    const interval = setInterval(() => {
      timeLeftRef.current -= 1;
      setDisplayTime(timeLeftRef.current);
      if (timeLeftRef.current <= 0) {
        onTimeout();
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [onTimeout]);

  const m = String(Math.floor(displayTime / 60)).padStart(2, "0");
  const s = String(displayTime % 60).padStart(2, "0");

  return <span>{`${m}:${s}`}</span>;
});

export default SessionTimer;
